import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY sont requis. Copie `.env.example` vers `.env` et remplis les valeurs."
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
    storageKey: "koloc-disk-index-auth",
  },
  global: {
    headers: { "x-koloc-client": "disk-index-web" },
  },
});

export const APP_URL: string = import.meta.env.VITE_APP_URL ?? window.location.origin;
